export default {
    getPaymentPlanById: state => id => {
      return state.paymentPlans.find(plan => plan._id === id);
  }
};
